// Angular
import { Component, OnInit } from '@angular/core';

// Ionic
import { NavParams } from '@ionic/angular/standalone';

//Third party
import { HorseWeightPipe } from '@amwager/util';

@Component({
  selector: 'feature-ion-show-runner-info',
  templateUrl: './show-runner-info.component.html',
  styleUrls: ['./show-runner-info.component.scss'],
  imports: [
    HorseWeightPipe
  ],
  standalone: true
})

export class ShowRunnerInfoComponent implements OnInit {

  receivedData!: any;

  constructor(
    private navParams: NavParams,
  ) { }

  ngOnInit() {
    this.receivedData = this.navParams.get('content');
  }

}
